/**
 * Money for one garment line.
 *
 * 2dp, matching the server and the brief's worked example - deliberately not
 * `draftAmount` from draft.ts, which rounds to whole rupees. Kept in its own
 * module so the editor file exports only its component (the fast-refresh rule),
 * and so the room modal and the grid can share the same arithmetic.
 */
import { toNumber } from '../draft'
import type { DraftItemLine } from '../draft'

export const lineAmount = (line: DraftItemLine): number =>
  Number((toNumber(line.quantity) * toNumber(line.unitPrice)).toFixed(2))

export const linesTotal = (lines: DraftItemLine[]): number =>
  Number(lines.reduce((sum, line) => sum + lineAmount(line), 0).toFixed(2))
